import angular from 'angular';
import { LoadParams } from '../../../shared/models/loadparams.model';
import { ISolicitacaoAlteracaoVT } from './models/solicitacaoalteracaovt.model';

export class MeurhSolicitacoesalteracoesvtsService {
    static $inject = ['$http', 'nsjRouting', '$rootScope', '$q'];

    public entity: ISolicitacaoAlteracaoVT;
    public entities: Array<ISolicitacaoAlteracaoVT> = [];
    public loaded: boolean = false;
    public constructors: any = {};
    public after: any = {};
    public filters: any = {};
    public loadParams: LoadParams;
    public loading_deferred: any = null;
    public filter: any = '';

    constructor(
        public $http: angular.IHttpService,
        public nsjRouting: any,
        public $rootScope: angular.IRootScopeService,
        public $q: angular.IQService
    ) {
        this.loadParams = new LoadParams();
    }

    reload(): Array<ISolicitacaoAlteracaoVT> {
        if (this.loading_deferred) {
            this.loading_deferred.resolve();
        }

        this.loadParams.finished = false;
        this.loadParams.to_load = 3;
        this.after = {};
        this.loaded = false;
        this.entities.length = 0;
        this.loadParams.busy = false;

        return this.load();
    }

    search(filter?: any): Array<ISolicitacaoAlteracaoVT> {
        if (typeof filter !== 'undefined') {
            this.filter = filter.search;

            Object.keys(this.filters).forEach((k: any): void => {
                delete this.filters[k];
            });

            for (let fil in filter.filters) {
                if (fil.indexOf('.') > -1) {
                    let filterSplit = fil.split('.');

                    this.filters[filterSplit[0]] = {};
                    this.filters[filterSplit[0]][filterSplit[1]] = filter.filters[fil];
                } else {
                    this.filters[fil] = filter.filters[fil];
                }
            }
        }

        return this.reload();
    }

    _load(constructors: any, offset: any, filter: any): angular.IHttpPromise<any> {
        this.loading_deferred = this.$q.defer();

        return this.$q((resolve: angular.IQResolveReject<any>, reject: angular.IQResolveReject<any>): void => {
            this.$http({
                method: 'GET',
                url: this.nsjRouting.generate('meurh_solicitacoesalteracoesvts_index', angular.extend({}, constructors, { 'offset': offset, 'filter': filter }, this.filters), true),
                timeout: this.loading_deferred.promise
            })
            .then((response: any): void => {
                resolve(response.data);
            })
            .catch((response: any): void => {
                reject(response);
            });
        });
    }

    load(): Array<ISolicitacaoAlteracaoVT> {
        if (!this.loadParams.busy && !this.loadParams.finished && this.loadParams.to_load > 0) {
            this.loadParams.busy = true;

            this._load(this.constructors, this.after, this.filter)
                .then((data: any): void => {
                    if (data.length > 0) {
                        for (let i = 0; i < data.length; i++) {
                            this.entities.push(data[i]);
                        }

                        this.after['created_at'] = this.entities[this.entities.length - 1]['created_at'];
                        this.after['solicitacao'] = this.entities[this.entities.length - 1]['solicitacao'];
                    }

                    if (data.length < 20) {
                        this.loadParams.finished = true;
                        this.$rootScope.$broadcast('meurh_solicitacoesalteracoesvts_list_finished', this.entities);
                    } else {
                        this.loadParams.finished = false;
                    }

                    this.loaded = true;
                    this.loadParams.to_load--;
                })
                .catch((error: any): void => {
                    if (error.xhrStatus !== 'abort') {
                        this.loadParams.finished = true;
                    }
                })
                .finally((): void => {
                    if (this.loaded || this.loadParams.finished) {
                        this.loadParams.busy = false;
                    }

                    this.load();
                });
        }

        return this.entities;
    }

    loadMore(): void {
        this.loadParams.to_load = 3;
        this.load();
    }

    find(identifier: string): ISolicitacaoAlteracaoVT | null {
        for (let i in this.entities) {
            if (this.entities[i]['solicitacao'] === identifier) {
                return this.entities[i];
            }
        }

        return null;
    }

    delete($identifier: any, force: boolean): void {
        if (typeof ($identifier) === 'object') {
            $identifier = $identifier['solicitacao'];
        }

        if ($identifier) {
            if (force || confirm('Tem certeza que deseja deletar?')) {
                this.loading_deferred = this.$q.defer();

                this.$http.delete(
                    this.nsjRouting.generate('meurh_solicitacoesalteracoesvts_delete', angular.extend(this.constructors, { 'id': $identifier }), true),
                    { timeout: this.loading_deferred.promise }
                )
                .then((response: any): void => {
                    this.$rootScope.$broadcast('meurh_solicitacoesalteracoesvts_deleted', {
                        entity: this.entity,
                        response: response
                    });
                })
                .catch((response: any): void => {
                    this.$rootScope.$broadcast('meurh_solicitacoesalteracoesvts_delete_error', {
                        entity: this.entity,
                        response: response
                    });
                });
            }
        }
    }

    _save(entity: ISolicitacaoAlteracaoVT,
        params: { empresa: string, estabelecimento: string },
        autosave: boolean): angular.IHttpPromise<any> {
        let method: string, url: string;

        if (entity['solicitacao']) {
            method = 'PUT';
            url = this.nsjRouting.generate('meurh_solicitacoesalteracoesvts_put', {
                'id': entity['solicitacao'],
                ...params
            }, true);
        } else {
            method = 'POST';
            url = this.nsjRouting.generate('meurh_solicitacoesalteracoesvts_create',
                angular.extend({}, this.constructors, params),
            true);
        }
        if (!autosave) {
            autosave = false;
            entity['$$__submitting'] = true;
        }
        let data = angular.copy(entity);
        if (data.hasOwnProperty('$$__submitting')) {
            delete data['$$__submitting'];
        }
        this.loading_deferred = this.$q.defer();
        return this.$http({
            method: method,
            url: url,
            data: data,
            timeout: this.loading_deferred.promise
        }).finally((): void => {
            if (!autosave) {
                entity['$$__submitting'] = false;
            }
        });
    }

    save(entity: ISolicitacaoAlteracaoVT,
        params: { empresa: string, estabelecimento: string },
        autosave: boolean = false): void {
        this._save(entity, params, autosave)
            .then((response: any): void => {
                if (response.data.solicitacao) {
                    entity['solicitacao'] = response.data.solicitacao;
                }
                entity['$$_saved'] = true;
                this.$rootScope.$broadcast('meurh_solicitacoesalteracoesvts_submitted', {
                    entity: entity,
                    response: response,
                    autosave: autosave
                });
            })
            .catch((response: any): void => {
                this.$rootScope.$broadcast('meurh_solicitacoesalteracoesvts_submit_error', {
                    entity: entity,
                    response: response,
                    autosave: autosave
                });
            });
    }

    fechar(entity: ISolicitacaoAlteracaoVT): angular.IHttpPromise<any> {
        this.loading_deferred = this.$q.defer();
        entity['$$__submitting'] = true;

        return this.$q((resolve: angular.IQResolveReject<any>, reject: angular.IQResolveReject<any>): void => {
            this.$http({
                method: 'post',
                url: this.nsjRouting.generate('meurh_solicitacoesalteracoesvts_fechar', { 'id': entity.solicitacao }, true),
                data: angular.copy(entity),
                timeout: this.loading_deferred.promise
            })
            .then((response: any): void => {
                resolve(response.data);
            })
            .catch((response: any): void => {
                reject(response);
            }).finally((): void => {
                entity['$$__submitting'] = false;
            });
        });
    }

    get(id: string) {
        this.loading_deferred = this.$q.defer();
        return this.$q<ISolicitacaoAlteracaoVT>((resolve, reject) => {
            this.$http.get<ISolicitacaoAlteracaoVT>(
                this.nsjRouting.generate('meurh_solicitacoesalteracoesvts_get', {
                    id
                }, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoesalteracoesvts_loaded', response.data);
                resolve(response.data);
            })
            .catch((response) => reject(response));
        });
    }
}
